const InnovationInitiatives = () => {
    return (
        <div className="InnovationInitiatives">
            <h3>Innovation Initiatives</h3>
            <div className="initiatives">
                <div className="initiative">
                    <b>Technology</b>
                    <span>
                        Dentons DNA (Digital News Alerts)
                    </span>
                    <span>
                        NextLaw Labs technology accelerator
                    </span>
                </div>
                <div className="initiative">
                    <b>Sustainability</b>
                    <span>Global ESG practice</span>
                    <span>Pro bono initiatives</span>
                </div>
            </div>
        </div>
    );
};

export default InnovationInitiatives;
